import App from '../../../vendor_core/core/src/App';
import { Tween } from '../../../vendor_core/core/src/Tween';
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import VendorSpinEndState from "../../../vendor_core/src/states/VendorSpinEndState";
import VOEReelGroup from "../view/VOEReelGroup";

export default class VOESpinEndState extends VendorSpinEndState {
  protected onResponse() {

    if(SpinModel.hasFreespinsWon()) {
      let continueCount = 0;
      let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        .getCurrentScene()
        .getSubView("ReelGroup") as VOEReelGroup;

        reelGroup.reels.forEach((reel) => {
          reel.symbols.forEach((symbol, index) => {
            if (index >= GameModel.gameConfig.reelExtraSymbols &&
                index < reel.symbols.length &&
                GameModel.gameConfig.spinifySymIds.indexOf(symbol.id) != -1)
            {
              const symSpine = reelGroup.getSymbolAt(reel.reelIndex, index - GameModel.gameConfig.reelExtraSymbols);
              symSpine.playAnimation ("win")
                .then(() => {
                  if(++continueCount == GameModel.gameConfig.spinifyReels.length) {
                    this.spinComplete()
                  }
                });
            }
          });
        });
    } else {
      this.spinComplete()
    }

  }
  public spinComplete() {
    let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
        .getCurrentScene()
        .getSubView("ReelGroup") as VOEReelGroup;

    App.dispatcher.emit(GameEvents.SPIN_COMPLETE);



    if (SpinModel.isInFreespins()) {
        CommandManager.execute(
            Commands.UPDATE_FREE_SPINS,
            SpinModel.freespinsNum.toString()
        )
    }
    // Delay after spin is finished
    if (reelGroup.hasBlackHole()) {
      Tween.delayedCall(0.7, () => this.exit())
    } else {
      this.exit();
    }
  }
}
